/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import { formatNumber } from "utils/formatNumber";

export default function OrdersModal({ show, onClose, orders = [], openOrderDetails, theme }) {
  if (!show) return null;

  // Filter logic from theme1: only show orders with orderNo and cityId
  const confirmedOrders = orders.filter(order => order.orderNo && order.cityId);

  const calculateTotal = (order) => {
    if (order.netAmount > 0) return order.netAmount;
    return (order.details || []).reduce((sum, item) => sum + (Number(item.lineTotal) || (Number(item.quantity) * Number(item.price)) || 0), 0);
  };

  return (
    <div className={`fixed inset-0 z-[25000] bg-gradient-to-br ${theme.bgGradient} overflow-y-auto p-0`}>
      <div className="w-full min-h-screen flex flex-col bg-transparent shadow-2xl relative">

        {/* Header */}
        <div className="flex items-center justify-between px-8 py-6 border-b border-white/10 bg-white/5 backdrop-blur-md sticky top-0 z-20">
          <div>
            <h3 className="text-xl font-bold text-white">طلباتي</h3>
          </div>
          <button onClick={onClose} className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-white/10 transition-colors text-white text-2xl">
            ×
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-6 space-y-4 custom-scrollbar">
          {confirmedOrders.length === 0 ? (
            <div className="py-20 text-center">
              <div className="text-4xl mb-4 opacity-20">📦</div>
              <p className="text-white/40 font-medium">لا يوجد طلبات مؤكدة بعد.</p>
            </div>
          ) : (
            confirmedOrders.map(order => (
              <div
                key={`${order.orderId}-${order.orderNo}`}
                className="group rounded-2xl border border-white/5 p-5 flex justify-between items-center gap-4 bg-white/[0.02] hover:bg-white/[0.05] hover:border-white/10 transition-all"
              >
                <div className="text-right flex-1 min-w-0">
                  <div className="font-black text-white text-base">
                    طلب #{order.orderNo || "-"}
                  </div>
                  <div className="flex items-center gap-2 mt-1.5">
                    <span className="text-[10px] text-white/30 uppercase font-bold px-2 py-0.5 rounded bg-white/5 border border-white/5">
                      {order.status || "قيد المعالجة"}
                    </span>
                  </div>
                  <div className="mt-3 text-[#fcfcfc] font-bold">
                    <span className="text-white/40 text-[11px] font-normal ml-1">الإجمالي:</span>
                    {formatNumber(calculateTotal(order))} <span className="text-[10px] opacity-40">IQD</span>
                  </div>
                </div>

                <button
                  onClick={() => openOrderDetails(order)}
                  className="px-6 py-3 rounded-xl text-xs font-black transition-all hover:scale-105 active:scale-95 shadow-lg shadow-black/20"
                  style={{
                    background: theme.primary,
                    color: "#000"
                  }}
                >
                  التفاصيل
                </button>
              </div>
            ))
          )}
        </div>

      </div>

      <style jsx="true">{`
        .custom-scrollbar::-webkit-scrollbar { width: 5px; }
        .custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
        .custom-scrollbar::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.05); border-radius: 10px; }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover { background: rgba(255, 255, 255, 0.1); }
      `}</style>
    </div>
  );
}
